import React from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/sidebar/Sidebar";
import Main from "../components/Main";
import Content from "../components/Content";
import Settings from "../components/Settings";
import Navbar from "../components/navbar/Navbar";
import docItems from "../components/sidebar/docItems";

const Doc = ({ children, demoMode = false }) => (
  <React.Fragment>
    <Wrapper>
      <Sidebar items={docItems} showFooter={true} />
      <Main>
        <Navbar demoMode={demoMode} />
        <Content>
          {children}
          <Outlet />
        </Content>
      </Main>
    </Wrapper>
  </React.Fragment>
);

export default Doc;
